export default "__VITE_ASSET__VIsLeY5G__"